import { handleActions } from 'redux-actions';

import * as actions from './bumpActions';
import { mkBumpStore } from './bumpTypes';

const bumpReducer = handleActions(
  {
    [actions.setBumpSocketState]: (state, { payload }) => state.merge({ socketState: payload }),
  },
  mkBumpStore(),
);

export default bumpReducer;
